/* global axios */
import ApiClient from '../ApiClient';

const idempotencyConfig = idempotencyKey => ({
  headers: { 'Idempotency-Key': idempotencyKey },
});

class EnterpriseAccountAPI extends ApiClient {
  constructor() {
    super('', { accountScoped: true, enterprise: true });
  }

  checkout() {
    return axios.post(`${this.url}checkout`);
  }

  subscription() {
    return axios.post(`${this.url}subscription`);
  }

  getLimits() {
    return axios.get(`${this.url}limits`);
  }

  toggleDeletion(action) {
    return axios.post(`${this.url}toggle_deletion`, {
      action_type: action,
    });
  }

  createTopupCheckout(options) {
    if (typeof options === 'number') {
      return axios.post(`${this.url}topup_checkout`, { credits: options });
    }

    const { packageKey, idempotencyKey } = options;
    return axios.post(
      `${this.url}topup_checkout`,
      { package_key: packageKey },
      idempotencyConfig(idempotencyKey)
    );
  }

  getBilling() {
    return axios.get(`${this.url}billing`);
  }

  getBillingTransactions(options = {}) {
    const { page, perPage, kind, status } = options;
    const params = {
      page,
      per_page: perPage,
      kind,
      status,
    };
    const definedParams = Object.fromEntries(
      Object.entries(params).filter(([, value]) => value !== undefined)
    );
    if (!Object.keys(definedParams).length) {
      return axios.get(`${this.url}billing_transactions`);
    }

    return axios.get(`${this.url}billing_transactions`, {
      params: definedParams,
    });
  }

  createSubscriptionCheckout(options) {
    if (typeof options === 'string') {
      return axios.post(`${this.url}subscription_checkout`, {
        plan_key: options,
      });
    }

    const { planKey, idempotencyKey } = options;
    return axios.post(
      `${this.url}subscription_checkout`,
      { plan_key: planKey },
      idempotencyConfig(idempotencyKey)
    );
  }

  changePlan(options) {
    if (typeof options === 'string') {
      return axios.post(`${this.url}change_plan`, { plan_key: options });
    }

    const { planKey, idempotencyKey } = options;
    return axios.post(
      `${this.url}change_plan`,
      { plan_key: planKey },
      idempotencyConfig(idempotencyKey)
    );
  }

  cancelSubscription(options) {
    if (!options?.idempotencyKey) {
      return axios.post(`${this.url}cancel_subscription`);
    }

    return axios.post(
      `${this.url}cancel_subscription`,
      {},
      idempotencyConfig(options.idempotencyKey)
    );
  }
}

export default new EnterpriseAccountAPI();
